// ORDER
export const FIELD_CLO_GUID = 'cloGuid';
export const FIELD_TEMPLATE_NAME = 'templateName';
export const FIELD_CLO_TOTAL_WEIGHT = 'cloTotalWeight';
export const FIELD_TEL_CREATION_MODE = 'telCreationMode';
export const FIELD_RETAINED_REFERENCES = 'retainedReferences';
export const FIELD_TEMPLATE_ENTERPRISE_GUID = 'templateEnterpriseGuid';
